export const environment = {
  production: true,
  type: 'stg',
  apiLocation: 'https://stg.teams.profiee.com/api/',
  baseUrl: 'https://stg.teams.profiee.com/',
  slackClientId: '384818818785.1047179210371',
  bugsnagApiKey: '6899f9d9ace7f2be2fd5fb173b048322',
  googleClientId: '430678005688-ee13mpj16rr00l14ttrdl57m3as4kgf4.apps.googleusercontent.com'
};
